import { Injectable } from '@angular/core';
import { ProfileDto, StatusService, UserListDto, UsersService } from 'apis/identity';
import { ValuesService } from './values.service';

@Injectable({
  providedIn: 'root'
})
export class MyUsersService {

  usersState = 'ACTIVE';
  states: Array<string>;
  myUsers: Array<UserListDto>;
  userToEdit: ProfileDto;
  userIdToEdit: number;

  constructor(private usersService: UsersService, 
              private statusService: StatusService,
              private valuesService: ValuesService) {
    this.statusService.statusGet().pipe().subscribe(data => {
      this.states = data as Array<string>;
      console.log(this.states);
    })
  }


}
